import { Injectable } from '@angular/core';
import { OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class JfifNormalizationService {
    normalizeJfifFiles(): OperatorFunction<File[], File[]> {
        return (source) =>
            source.pipe(
                map((files) => files.map((file) => this.normalize(file)))
            );
    }

    private normalize(file: File): File {
        if (!file.name.toLowerCase().endsWith('.jfif')) return file;
        const newName = file.name.slice(0, -5) + '.jpg';
        return new File([file], newName, { type: 'image/jpeg' });
    }
}
